var _vars = require('../../vars')._vars;

var DIFY_BASE_URL = 'https://www.' + _vars.apiEnv + 'medscape.com/conversationalapi/api/v2';

var controller;

function generateToken() {
    return fetch(DIFY_BASE_URL + '/Auth/tokens/generate', {
		method: 'post',
		mode: 'cors',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
		}
	}).then( function(res) {
		return res.json();
	}).catch( function(e) {
		console.log(e);
	});;
}

function initializeStream(query) {
    controller = new AbortController();
    var signal = controller.signal;
	var reqBody = {
		"query": query
	};
	if( _vars.conversationId ) {
		reqBody.thread_id = _vars.conversationId
	}
	if(_vars.promptId) {
		reqBody.prompt_id = _vars.promptId;
		_vars.promptId = null;
	}

	// Add contextual information
	var fullWidthPage = document.querySelector('.ai-search-full-width-container');
	if(!fullWidthPage || _vars.articleParams) {
		var artGuid = '';
		var artTitle = '';
		var artContentType = '';

		if (_vars.articleParams) {
			// Use URL parameters if available (for PDQ flows)
			artGuid = _vars.articleParams.guid;
			artTitle = _vars.articleParams.title;
			artContentType = _vars.articleParams.contentType;
		} else if (_vars.a2aArticleContext) {
			// Use A2A context captured from deep dive click
			artGuid = _vars.a2aArticleContext.article_guid;
			artTitle = _vars.a2aArticleContext.article_title;
			artContentType = _vars.a2aArticleContext.content_type_guid;
			// Clear after use so subsequent queries use current PageMetadata
			_vars.a2aArticleContext = null;
		} else if (_vars.isSearchResultsPage) {
			artGuid = null;
			artTitle = '';
			artContentType = null;
		} else if(Number(PageMetadata.pageSegVars.cmsid) == 2) {
			artGuid = PageMetadata.pageSegVars.asst;
			artTitle = document.title;
			artContentType = String(window.PageMetadata.pageSegVars.ctype);
		} else {
			artGuid = PageMetadata.pageSegVars.art.replace(/\D/g, '');
			artTitle = document.title;
			artContentType = String(window.PageMetadata.pageSegVars.ctype);
		}
		
		reqBody.contextual_info = {
			article_guid: artGuid,
			article_title: artTitle,
			content_type_guid: artContentType,
			user_specialty: window.PageMetadata.addProfile.spdesc,
			user_channel: window.breakpoint == 1 ? "Web mobile" : "Web desktop",
			user_platform: "V2",
			user_country: window.PageMetadata.addProfile.co
		};
	}

    return fetch(DIFY_BASE_URL + '/Chat/runs/stream', {
        method: 'POST',
        mode: 'cors',
		credentials: 'include',
        headers: {
            'Authorization': _vars.token,
            'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
        },
        body: JSON.stringify(reqBody),
        signal: signal
    });
}

function stopGenerate() {
	if (controller) {
		controller.abort();
	}
	// Aborting cancels the run, so the thread is left with an incomplete run that the backend
	// rejects (404) if the next query tries to continue it (thread_id = conversationId). Reset
	// the conversation so the next query starts fresh instead of reusing the cancelled thread.
	_vars.conversationId = '';
    if(!_vars.taskId) {
		return;
    }
	// Capture and clear the taskId up front so repeated stops (e.g. clicking the cross/stop
	// multiple times) don't re-POST /Chat/runs/<taskId>/stop on an already-stopped run and 404.
	var taskId = _vars.taskId;
	_vars.taskId = '';
    return fetch(DIFY_BASE_URL + '/Chat/runs/'+ taskId +'/stop', {
		method: 'post',
		mode: 'cors',
		credentials: 'include',
		headers: {
            'Authorization': _vars.token,
            'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
		}
	}).catch(function() { /* stop is best-effort; ignore network/404 errors */ });
}
function getHistory(conversationId) {
	const id = conversationId || _vars.conversationId;
    return fetch(DIFY_BASE_URL + '/Chat/threads/'+ id, {
		method: 'get',
		mode: 'cors',
		credentials: 'include',
		headers: {
            'Authorization': _vars.token,
            'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
		}
	}).then(function(res) {
		return res.json();
	});
}

function getAllHistory(offset, limit) {
	var url = DIFY_BASE_URL + '/Chat/threads';
	if(offset) {
		url += '?limit=20&offset=' + offset;
	}
    return fetch(url, {
		method: 'get',
		mode: 'cors',
		credentials: 'include',
		headers: {
            'Authorization': _vars.token,
            'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
		}
	}).then( function(res) {
		return res.json();
	}).catch( function(e) {
		console.log(e);
	});
}

function getInitialPrompts() {
	return fetch(DIFY_BASE_URL + '/Prompts/specialty/' + (typeof PageMetadata.userSegVars.usp != 'string' || Number(PageMetadata.userSegVars.usp) == 0 ? '-1' : PageMetadata.userSegVars.usp), {
		method: 'get',
		mode: 'cors',
		credentials: 'include',
		headers: {
            'Authorization': _vars.token,
            'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
		}
	});
}
           

function sendEvent(eventData) {
		var shared = require('../../shared');
		var analyticsAttrs = shared.getAnalyticsAttributes();

		// Get current intent value (only if available from current query's API response)
		var currentIntent = (analyticsAttrs.messageIntent && analyticsAttrs.messageIntent !== 'no-val') ? analyticsAttrs.messageIntent : null;

		// Get current leadConcept value (from analytics or _vars.leadConcept)
		var currentLeadConcept = null;
		if (analyticsAttrs.leadConceptId && analyticsAttrs.leadConceptId !== 'no-val') {
			currentLeadConcept = analyticsAttrs.leadConceptId;
		} else if (_vars.leadConcept && _vars.leadConcept.value) {
			currentLeadConcept = _vars.leadConcept.value;
		}

		// Determine leadConceptSource - only set if we have a valid leadConcept
		var currentLeadConceptSource = null;
		if (currentLeadConcept) {
			if (_vars.leadConcept && _vars.leadConcept.source === 'url') {
				currentLeadConceptSource = 'PDQ';
			} else {
				currentLeadConceptSource = 'Organic';
			}
		}

	var payload = {
		"eventName": "ConvSearchWeb",
		"eventProperties": {
		"regId": String(PageMetadata.userSegVars.gd),
		"profession": PageMetadata.addProfile.profdesc,
		"specialty": PageMetadata.addProfile.spdesc,
		"countryCode": PageMetadata.addProfile.co,
		"question": _vars.searchResult.question,
		"answerId": _vars.taskId,
		"answer": _vars.searchResult.answer,
		"responseTimeFirstToken": _vars.searchResult.responseTimeFirstToken,
		"responseTimeToCompletion": _vars.searchResult.responseTime,
		"messageChannel": window.breakpoint == 1 ? "Web mobile" : "Web desktop",
		"agentPlatform": 'V2',
		"correlationId": _vars.correlationId,
		"userAgent": navigator.userAgent,
		"conversationId": _vars.conversationId,
		"runId": _vars.runId,
		"qid": _vars.queryId, // MEDAIS-2052: Frontend-generated QUERYID
		"eventTimestamp":null,
		"requestId":_vars.runId,
		"stepName":null,
		"latencyMsFromQuery":null,
		"latencyMsFromAnswerEnd":null,
		// Required fields for MEDAIS-1795 - only set if available, will be removed if null by cleanup loop below
		"querySource": _vars.querySource || 'Organic',
		"intent": currentIntent,
		"leadConceptId": currentLeadConcept,
		"leadConceptSource": currentLeadConceptSource
		}
	}
	
	if (typeof eventData == 'object') {
		if(eventData.eventName) {
			payload.eventName = eventData.eventName;
		}
		if(eventData.eventProperties) {
			Object.assign(payload.eventProperties, eventData.eventProperties);
		}
	}
	
	for (var key in payload.eventProperties) {
		if(!payload.eventProperties[key]) {
			delete payload.eventProperties[key];
		}
	}	
	return fetch(DIFY_BASE_URL + '/Event', {
		method: 'post',
		mode: 'cors',
		credentials: 'include',
		headers: new Headers({
			'Content-Type': 'application/json',
			'Authorization': _vars.token,
            'X-Correlation-ID': _vars.correlationId
		}),
		body: JSON.stringify(payload)
	}).then(function(res) {
		return res.json();
	})
}


function renameThread(threadId, newName) {
    return fetch(DIFY_BASE_URL + '/Chat/threads/' + threadId, {
        method: 'put',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Authorization': _vars.token,
            'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
        },
        body: JSON.stringify({
            name: newName
        })
    }).then(function(res) {
        return res.json();
    });
}

function deleteThread(threadId) {
    return fetch(DIFY_BASE_URL + '/Chat/threads/' + threadId, {
        method: 'delete',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Authorization': _vars.token,
            'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
        }
    }).then(function(res) {
        return res.json();
    });
}

function getArticleInsights(query) {
    var reqBody = {};
	
	var artGuid = '';
	var artTitle = document.title;
	var artContentType = String(window.PageMetadata.pageSegVars.ctype);
	
	if (_vars.a2aArticleContext) {
		// Use A2A article context captured from deep dive click
		artGuid = _vars.a2aArticleContext.article_guid;
		artTitle = _vars.a2aArticleContext.article_title;
		artContentType = _vars.a2aArticleContext.content_type_guid;
	} else if (_vars.articleParams) {
		artGuid = _vars.articleParams.guid;
		artTitle = _vars.articleParams.title;
		artContentType = _vars.articleParams.contentType;
	} else if (Number(PageMetadata.pageSegVars.cmsid) == 2) {
		artGuid = PageMetadata.pageSegVars.asst;
	} else {
		artGuid = PageMetadata.pageSegVars.art.replace(/\D/g, '');
	}
	reqBody.contextual_info = {
		article_guid: artGuid,
		article_title: artTitle,
		content_type_guid: artContentType,
		user_specialty: window.PageMetadata.addProfile.spdesc,
		user_channel: window.breakpoint == 1 ? 'Web mobile' : 'Web desktop',
		user_platform: 'V2',
		user_country: window.PageMetadata.addProfile.co
	};
	
	// Clear A2A context after use to prevent it from affecting subsequent queries
	_vars.a2aArticleContext = null;

    return fetch(DIFY_BASE_URL + '/Article/insights', {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Authorization': _vars.token,
            'Content-Type': 'application/json',
            'X-Correlation-ID': _vars.correlationId
        },
        body: JSON.stringify(reqBody),
    });
}

function getArticlePrompts() {
	var reqBody = {};

	reqBody.contextual_info = {
		article_guid: String(window.CURRENT_DRUG_ID),
		article_title: document.title,
		article_url: window.location.href,
		content_type_guid: String(window.PageMetadata.pageSegVars.ctype),
		user_specialty: window.PageMetadata.addProfile.spdesc,
		user_channel: window.breakpoint == 1 ? 'Web mobile' : 'Web desktop',
		user_platform: 'V2',
		user_country: window.PageMetadata.addProfile.co
	};

	return fetch(DIFY_BASE_URL + '/Article/prompts', {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers: {
			'Authorization': _vars.token,
			'Content-Type': 'application/json',
			'X-Correlation-ID': _vars.correlationId
		},
		body: JSON.stringify(reqBody),
	});
}

function getCaqQuestions(articleContext, signal) {
	articleContext = articleContext || {};
	// Every CAQ wrapper (entry + A2A feed) is stamped by the mixin with its OWN
	// article context via data-* attributes, so we use those directly. No need to
	// resolve from PageMetadata / a2aArticleContext here — that path is for the
	// deep-dive insights flow, not the CAQ auto-load.
	var reqBody = {
		contextual_info: {
			article_guid: articleContext.guid,
			article_title: articleContext.title,
			content_type_guid: articleContext.contentTypeGuid,
			user_specialty: window.PageMetadata.addProfile.spdesc,
			user_channel: window.breakpoint == 1 ? 'Web mobile' : 'Web desktop',
			user_platform: 'V2',
			user_country: window.PageMetadata.addProfile.co
		}
	};

	return fetch(DIFY_BASE_URL + '/Article/caq', {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers: {
			'Authorization': _vars.token,
			'Content-Type': 'application/json',
			'X-Correlation-ID': _vars.correlationId
		},
		body: JSON.stringify(reqBody),
		signal: signal
	});
}

module.exports = {
    generateToken: generateToken,
    initializeStream: initializeStream,
	getArticleInsights: getArticleInsights,
	getArticlePrompts: getArticlePrompts,
	getCaqQuestions: getCaqQuestions,
    stopGenerate: stopGenerate,
    sendEvent: sendEvent,
    getHistory: getHistory,
    getAllHistory: getAllHistory,
    renameThread: renameThread,
    deleteThread: deleteThread,
	getInitialPrompts: getInitialPrompts
};
